import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useMemo } from 'react'
import { Switch } from '~/src/components/ui/switch'

const DarkModeToggle: React.FC = () => {
  const { setTheme, resolvedTheme } = useTheme()

  const onChange = (checked: boolean) => {
    setTheme(checked ? 'dark' : 'light')
  }

  const checked = resolvedTheme === 'dark'

  const icon = useMemo(
    () =>
      checked ? (
        <Sun size={14} className='text-black opacity-50' />
      ) : (
        <Moon size={14} className='text-black opacity-50' />
      ),
    [checked]
  )

  return (
    <div className='inline-flex items-center'>
      <Switch checked={checked} onCheckedChange={onChange} icon={icon} />
    </div>
  )
}

export default DarkModeToggle
